import React from 'react';
import {IconButton} from '@mui/material';

export default React.memo(IconButton);
